import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useApiKeyQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES
    const apiKeysListQuery = useQuery({
        queryKey: ["api-keys", "list"],
        queryFn: () => axiosPrivate.get("api-keys/").then(r => r.data),
    });

    // MUTATIONS
    const createApiKeyMutation = useMutation({
        mutationFn: (data) => axiosPrivate.post("api-keys/", data).then(r => r.data),
        onSuccess: (...args) => {
            queryClient.invalidateQueries(["api-keys"]);
        },
    });

    const deleteApiKeyMutation = useMutation({
        mutationFn: (id) => axiosPrivate.delete(`api-keys/${id}/`).then(r => r.data),
        onSuccess: (...args) => {
            queryClient.invalidateQueries(["api-keys"]);
        },
    });

    return {
        // Queries
        apiKeysListQuery,

        // Mutations
        createApiKeyMutation,
        deleteApiKeyMutation,
    };
}
